import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

/**
 * BiasBadge - shows directional bias (long/short/neutral) with confidence.
 * Compliance: this never says "go long" / "go short". It is described as a
 * directional *eğilim* (bias) indicating which side conditions currently favor.
 */
export default function BiasBadge({ bias, compact = false, testid }) {
    const dir = bias?.direction || 'neutral';
    const conf = bias?.confidence ?? 0;

    const cfg = {
        long: {
            Icon: TrendingUp,
            label: 'Yukarı Eğilim',
            compactLabel: 'LONG',
            wrap: 'border-emerald-400/40 bg-emerald-400/10 text-emerald-300',
            bar: 'bg-emerald-400',
        },
        short: {
            Icon: TrendingDown,
            label: 'Aşağı Eğilim',
            compactLabel: 'SHORT',
            wrap: 'border-rose-500/40 bg-rose-500/10 text-rose-300',
            bar: 'bg-rose-500',
        },
        neutral: {
            Icon: Minus,
            label: 'Nötr',
            compactLabel: 'NÖTR',
            wrap: 'border-slate-600 bg-slate-600/40 text-slate-300',
            bar: 'bg-slate-500',
        },
    }[dir];

    if (compact) {
        return (
            <div
                className={`inline-flex items-center gap-1.5 border rounded-sm px-1.5 py-0.5 ${cfg.wrap}`}
                data-testid={testid || `bias-${dir}`}
                title={`Yön eğilimi: ${cfg.label} · güven ${conf}% (long sinyalleri: ${bias?.long_strength?.toFixed?.(0) ?? 0} / short sinyalleri: ${bias?.short_strength?.toFixed?.(0) ?? 0})`}
            >
                <cfg.Icon className="h-2.5 w-2.5" />
                <span className="text-[10px] font-medium uppercase tracking-wider">{cfg.compactLabel}</span>
                {dir !== 'neutral' && <span className="text-[10px] font-mono tabular-nums opacity-80">{conf}</span>}
            </div>
        );
    }

    return (
        <div className={`border rounded-md p-3 ${cfg.wrap}`} data-testid={testid || `bias-card-${dir}`}>
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <cfg.Icon className="h-4 w-4" />
                    <span className="text-xs font-medium uppercase tracking-wider">{cfg.label}</span>
                </div>
                <span className="font-mono tabular-nums text-xs">{conf}%</span>
            </div>
            <div className="mt-2 h-1 w-full bg-slate-900/30 rounded-sm overflow-hidden">
                <div className={`h-full ${cfg.bar}`} style={{ width: `${conf}%` }} />
            </div>
        </div>
    );
}
